import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Experiences from "../pages/experiences/page";
import Gallery from "../pages/gallery/page";
import Inquiry from "../pages/inquiry/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/experiences",
    element: <Experiences />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/inquiry",
    element: <Inquiry />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
